module.exports = __webpack_public_path__ + "static/media/watch-calculator.b44e0717.svg";